<template>
    <div>
      <b-form-group label-align="right" :label="$t('Vendor')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input required type="number" v-model="newRadiusAttr.vendor"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Attribute')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input required type="number" v-model="code"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input required type="text" v-model="newRadiusAttr.value"/>
        <b-form-checkbox v-if="isValidationAttr" v-model="isTunnel">{{ $t('Is value tunnel parameter?') }}</b-form-checkbox>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-radio-group v-model="newRadiusAttr.attr_type" name="radioType" :disabled="isTunnel">
          <b-form-radio :value=1>{{ $t('Number') }}</b-form-radio>
          <b-form-radio :value=2>{{ $t('String') }}</b-form-radio>
          <b-form-radio :value=3>{{ $t('IP') }}</b-form-radio>
          <b-form-radio :value=4>{{ $t('Binary') }}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Settings in services')" v-if="isISGprofile" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-group :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="newRadiusAttr.properties[0].property_value" :options="services"/>
        </b-form-group>
        <b-form-group :label="$t('Account state')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="newRadiusAttr.properties[1].property_value" :options="accountState"/>
        </b-form-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Use in')" v-if="!isISGprofile" :disabled="isRadiusAccounts" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-row>
          <b-col>
            <b-form-checkbox v-model="isAccessAccept" :disabled="isRemoveAttr">Access-accept</b-form-checkbox>
            <b-form-checkbox v-model="isDisconnectRequest" :disabled="isRemoveAttr">Disconnect-request</b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="isCoaRequest" :disabled="isRemoveAttr">CoA-request</b-form-checkbox>
            <b-form-checkbox v-model="isAccessReject" :disabled="isRemoveAttr">Access-reject</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Usage settings')" v-if="!isRadiusAccounts" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-row>
          <b-col>
            <b-form-checkbox v-model="isReplaceAttr" :disabled="isRemoveAttr">{{ $t('Replace attr.') }}</b-form-checkbox>
            <b-form-checkbox v-model="isRemoveAttr">{{ $t('Remove attr.') }}</b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="isEnableScripting" :disabled="isRemoveAttr">{{ $t('Enable scripting') }}</b-form-checkbox>
            <b-form-checkbox v-model="isIfNotExists" :disabled="isRemoveAttr">{{ $t('Add if not exists') }}</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Expire settings')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="datetime-local" :disabled="!isActivate" v-model="newRadiusAttr.expire_date"/>
        <b-form-checkbox v-model="isActivate">{{ $t('Activate') }}</b-form-checkbox>
      </b-form-group>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveRadiusAttr">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAddRadiusAttr">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </div>
</template>

<script>

import moment from 'moment'

export default {
  props: {
    isISGprofile: false,
    isRadiusAccounts: false,
    radiusAttrCoAItems: null,
    radiusAttrItems: null,
    isRadiusAttrCoa: false,
    isEditRadiusAttr: null,
    rowRadiusAttr: null
  },
  data () {
    return {
      accountState: [
        { text: this.$i18n.t('Blocked'), value: '1' },
        { text: this.$i18n.t('Unbloked'), value: '0' },
        { text: this.$i18n.t('All states'), value: '' }
      ],
      code: '',
      isValidationAttr: false,
      isActivate: false,
      newRadiusAttr: {
        'value': '',
        'attr_type': 2,
        'attr_value': '',
        'code': 0,
        'expire_date': moment().format('YYYY-MM-DDThh:mm'),
        'properties': [
          {'property_type': 1,
            'property_value': ''},
          {'property_type': 2,
            'property_value': ''}
        ],
        'tag': 0,
        'usage_flags': 0,
        'vendor': ''
      },
      radioTypeList: [
        { text: this.$i18n.t('String'), value: 2 },
        { text: this.$i18n.t('Number'), value: 1 },
        { text: 'IP', value: 3 },
        { text: this.$i18n.t('Binary'), value: 4 }
      ],
      flagAccessAccept: 1,
      flagAccessReject: 2,
      flagDisconnectRequest: 4,
      flagCoaRequest: 8,
      flagReplaceAttr: 16,
      flagEnableScripting: 32,
      flagRemoveAttr: 64,
      flagIsTunnel: 128,
      flagSetIfNotExists: 256,
      isAccessAccept: true,
      isAccessReject: false,
      isDisconnectRequest: false,
      isCoaRequest: false,
      isReplaceAttr: false,
      isEnableScripting: false,
      isRemoveAttr: false,
      isTunnel: false,
      isIfNotExists: true
    }
  },
  methods: {
    load () {
      if (this.isEditRadiusAttr) {
        this.newRadiusAttr = this.rowRadiusAttr
        this.code = this.newRadiusAttr.code
        this.newRadiusAttr.properties[0].property_value = this.rowRadiusAttr.properties[0].property_value
        this.newRadiusAttr.properties[1].property_value = this.rowRadiusAttr.properties[1].property_value
        if (this.newRadiusAttr.expire_date !== 2000000000) this.isActivate = true
        this.newRadiusAttr.expire_date = moment(Number(this.newRadiusAttr.expire_date) * 1000).format('YYYY-MM-DDThh:mm')
        if (this.newRadiusAttr.usage_flags) {
          if (this.newRadiusAttr.usage_flags & this.flagAccessAccept) this.isAccessAccept = true
          if (this.newRadiusAttr.usage_flags & this.flagAccessReject) this.isAccessReject = true
          if (this.newRadiusAttr.usage_flags & this.flagDisconnectRequest) this.isDisconnectRequest = true
          if (this.newRadiusAttr.usage_flags & this.flagCoaRequest) this.isCoaRequest = true
          if (this.newRadiusAttr.usage_flags & this.flagReplaceAttr) this.isReplaceAttr = true
          if (this.newRadiusAttr.usage_flags & this.flagEnableScripting) this.isEnableScripting = true
          if (this.newRadiusAttr.usage_flags & this.flagRemoveAttr) this.isRemoveAttr = true
          if (this.newRadiusAttr.usage_flags & this.flagIsTunnel) this.isTunnel = true
          if (this.newRadiusAttr.usage_flags & this.flagSetIfNotExists) this.isIfNotExists = true
        } else {
          this.isAccessAccept = false
          this.isIfNotExists = false
        }
      }
    },
    saveRadiusAttr () {
      if (!this.newRadiusAttr.vendor) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field vendor'), 'Error')
        return
      }
      if (!this.newRadiusAttr.value) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field value'), 'Error')
        return
      }
      if (!this.code) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field attribute'), 'Error')
        return
      }
      if (this.newRadiusAttr.attr_type === 3 && !this.isTunnel) {
        if (!this.validationIP()) return
      }
      if (this.newRadiusAttr.attr_type === 1 && !this.isTunnel) {
        if (!this.validationNum()) return
      }
      if (this.newRadiusAttr.attr_type === 4 && !this.isTunnel) {
        if (!this.validationBinary()) return
      }
      if (this.isTunnel && ([64, 65, 66, 67, 69, 81, 82, 83, 90, 91].includes(Number(this.code)))) {
        if (!this.validationTunnel()) return
      }

      switch (this.newRadiusAttr.attr_type) {
        case 1:
          this.newRadiusAttr.attrType = this.$i18n.t('Number')
          break
        case 2:
          this.newRadiusAttr.attrType = this.$i18n.t('String')
          break
        case 3:
          this.newRadiusAttr.attrType = 'IP'
          break
        case 4:
          this.newRadiusAttr.attrType = this.$i18n.t('Binary')
          break
      }
      this.newRadiusAttr.usage_flags = 0
      this.newRadiusAttr.usage_flags += this.isAccessAccept ? this.flagAccessAccept : 0
      this.newRadiusAttr.usage_flags += this.isAccessReject ? this.flagAccessReject : 0
      this.newRadiusAttr.usage_flags += this.isDisconnectRequest ? this.flagDisconnectRequest : 0
      this.newRadiusAttr.usage_flags += this.isCoaRequest ? this.flagCoaRequest : 0
      this.newRadiusAttr.usage_flags += this.isReplaceAttr ? this.flagReplaceAttr : 0
      this.newRadiusAttr.usage_flags += this.isEnableScripting ? this.flagEnableScripting : 0
      this.newRadiusAttr.usage_flags += this.isRemoveAttr ? this.flagRemoveAttr : 0
      this.newRadiusAttr.usage_flags += this.isTunnel ? this.flagIsTunnel : 0
      this.newRadiusAttr.usage_flags += this.isIfNotExists ? this.flagSetIfNotExists : 0
      if (this.isISGprofile) {
        for (let el of this.services) {
          if (el.value === this.newRadiusAttr.properties[0].property_value) {
            this.newRadiusAttr.service = el.text
          }
        }
      }
      if (this.isRadiusAttrCoa) {
        for (let el of this.accountState) {
          if (el.value === this.newRadiusAttr.properties[1].property_value) {
            this.newRadiusAttr.event = el.text
          }
        }
      }
      if (this.isTunnel) {
        this.newRadiusAttr.tag = Number(this.newRadiusAttr.value.split(':')[1])
        this.newRadiusAttr.attr_value = Number(this.newRadiusAttr.value.split(':')[2])
      } else {
        this.newRadiusAttr.attr_value = this.newRadiusAttr.value
      }
      this.newRadiusAttr.code = Number(this.code)
      this.newRadiusAttr.vendor = Number(this.newRadiusAttr.vendor)
      if (this.isActivate) {
        this.newRadiusAttr.expire_date = Number(Date.parse(this.newRadiusAttr.expire_date)) / 1000
      } else {
        this.newRadiusAttr.expire_date = 2000000000
      }
      if (this.newRadiusAttr.attr_type === 1) {
        this.newRadiusAttr.attr_value = Number(this.newRadiusAttr.attr_value)
      }
      if (this.isEditRadiusAttr && !this.isRadiusAttrCoa) {
        this.hideAddRadiusAttr()
      } else if (!this.isEditRadiusAttr && !this.isRadiusAttrCoa) {
        this.radiusAttrItems.push(this.newRadiusAttr)
        this.hideAddRadiusAttr()
      } else if (this.isEditRadiusAttr && this.isRadiusAttrCoa) {
        this.hideAddRadiusAttr()
      } else if (!this.isEditRadiusAttr && this.isRadiusAttrCoa) {
        this.radiusAttrCoAItems.push(this.newRadiusAttr)
        this.hideAddRadiusAttr()
      }
    },
    hideAddRadiusAttr () {
      this.$emit('hideAddRadiusAttr')
    },
    validationIP () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newRadiusAttr.value.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationNum () {
      if (Number(this.newRadiusAttr.value)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Value field is invalid'), 'Error')
        return false
      }
    },
    validationBinary () {
      let goodChars = '^[0-9a-fA-F]+$'
      if (this.newRadiusAttr.value.length % 2 === 0 && this.newRadiusAttr.value.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect binary format'), 'Error')
        return false
      }
    },
    validationTunnel () {
      let goodChars = '^:(.*\\d):(.*\\d)'
      let arrValidation = this.newRadiusAttr.value.match(goodChars)
      if (arrValidation && arrValidation[1] < 32) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect tunnel format'), 'Error')
        return false
      }
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    code: function (val) {
      if ([64, 65, 66, 67, 69, 81, 82, 83, 90, 91].includes(Number(val))) {
        this.isValidationAttr = true
      } else {
        this.isValidationAttr = false
      }
    }
  },
  computed: {
    services () {
      if (this.isISGprofile) {
        let res = this.$store.getters['Tariffing/SERVICES']
        let services = []
        let newEl = {
          value: '',
          text: this.$i18n.t('All services')
        }
        services.push(newEl)
        for (let el of res) {
          let isType = false
          let newEl = {
            value: 0,
            text: ''
          }
          switch (el.service_type) {
            case 3:
              isType = true
              break
            case 4:
              isType = true
              break
            case 5:
              isType = true
              break
            case 6:
              isType = true
              break
          }
          if (isType) {
            newEl.value = el.service_id
            newEl.text = el.service_name + '(' + el.service_id + ')'
            services.push(newEl)
          }
        }
        return services
      } else {
        return []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formRadiusAttributs.vue